import React, { Component, Fragment } from 'react';
import styles from './TimeLine.module.css';
import ReactMarkDown from 'react-markdown';
import moment from 'moment';
import propTypes from 'prop-types';

export default class TimeLine extends Component {
  static contextTypes = {
    router: propTypes.object,
  };

  navTo = item => {
    const { navTo, catogary } = this.props;
    navTo(item._id, catogary);
  };

  renderComment = comment => {
    return (
      <div key={comment._id} className={styles.singleCommentContainer}>
        <img
          alt={comment.user}
          className={styles.commentor}
          src="/img/avatar.png"
        />
        <div className={styles.commentContent}>
          <div className={styles.singleCommentTop}>
            <div className={styles.commentUser}>{comment.user}</div>
            <div className={styles.commentCreate}>
              {moment(comment.createdAt).fromNow()}
            </div>
          </div>
          <ReactMarkDown
            className={styles.commentMarkDown}
            source={comment.content}
          />
        </div>
      </div>
    );
  };

  renderStatus = item => {
    const content = `${item.description} ${
      item.createdAt ? moment(item.createdAt).fromNow() : ''
    }`;
    return (
      <div key={item._id} className={styles.historyContainer}>
        <ReactMarkDown source={content} />
      </div>
    );
  };

  combineTimeLine = (comments, history) => {
    const { request } = this.props;
    const timeline = [];
    for (let i in comments) {
      comments[i].timelineType = 'comment';
      timeline.push(comments[i]);
    }

    for (let i in history) {
      history[i].timelineType = 'history';
      timeline.push(history[i]);
    }

    timeline.sort((a, b) => {
      const valueA = new Date(a.createdAt).getTime();
      const valueB = new Date(b.createdAt).getTime();
      return valueA < valueB ? -1 : 1;
    });
    if (new Date(request.closedAt) > new Date('1995-12-17T03:24:00')) {
      const approveItem = timeline.find(
        item => item.description && item.description.indexOf('Approved') !== -1
      );
      if (approveItem) {
        const user = approveItem.user;
        timeline.push({
          description: `${user} closed the review request `,
          timelineType: 'history',
        });
      }
    }
    return timeline;
  };

  postComment = type => {
    const { createComment, user, request } = this.props;

    const content = this.refs['commentBox'].value;
    if (!content) return;
    const comment = {
      user: user.username,
      content,
      modelId: request.modelId,
      type,
    };

    createComment(comment, request.catogary).then(() => {
      this.refs['commentBox'].value = '';
    });
  };

  render() {
    const { comments, history, user, request } = this.props;
    const timeline = this.combineTimeLine(comments, history);
    return (
      <div className={styles.container}>
        {this.renderComment(
          {
            user: request.creator,
            createdAt: request.createdAt,
            content: request.description,
          },
          true
        )}
        <div className={styles.outputContainer}>
          <img
            className={styles.requestOutput}
            src="https://resources.clara.io/9935f22c4d033e2e49851073777a142a?filename=Chair%20for%20V-Ray%20Rendering%20-%20v2-vrayv2.jpg"
          />
        </div>
        <div className={styles.inputLabel}>Timeline </div>
        {timeline.map(
          item =>
            item.timelineType === 'comment'
              ? this.renderComment(item)
              : this.renderStatus(item)
        )}
        <div className={styles.commentContainer}>
          <div className={styles.commentTitle}> Add a Comment </div>
          <textarea ref="commentBox" className={styles.commentBox} />
          <div className={styles.buttonContainer}>
            <button
              className={styles.postComment}
              onClick={e => this.postComment('normal')}
            >
              Post Comment
            </button>
            {request.reviewers.indexOf(user.username) !== -1 && (
              <Fragment>
                <button
                  className={styles.attachFile}
                  onClick={e => this.postComment('change')}
                >
                  Request Change
                </button>
                <button
                  className={styles.approveBtn}
                  onClick={e => this.postComment('approve')}
                >
                  Approve
                </button>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TimeLine/index.js